import { Component, OnInit } from '@angular/core';
import { HrmsService } from '../hrms.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-hrms-landing-page',
  templateUrl: './hrms-landing-page.component.html',
  styleUrls: ['./hrms-landing-page.component.scss']
})
export class HrmsLandingPageComponent implements OnInit {
  isCollapsed: boolean = false;
  isContainerCollapsed: boolean = true;

  reportsActive = false;

  containerWidth = '';

  activeView = 'hrmssubject';
  roleDetails: any;

  Grievanceuser1 = false;
  Grievanceuser2 = false;
  constructor(private Service: HrmsService, private spinner: NgxSpinnerService,) { }
  ngOnInit(): void {
    this.Service.collapsed$.subscribe(state => {
      this.isCollapsed = state;
    });
    this.Service.view$.subscribe(view => {
      this.activeView = view;
      // console.log('this.activeView',this.activeView);
    });
     this.Service.width$.subscribe(width => {
      this.containerWidth = width;
    });

    this.Service.reportsSelected$.subscribe(flag => {
    this.reportsActive = flag;
  });
  
  }
}
